import submit from "submit-form";

/**
 * Function to handle generic refresh (modals or cleaning)
 * @param {*} params
 */
export const handleGenericRefresh = (params = {}) => {
  submit(`/actions/refresh/?`, {
    method: "GET",
    body: { ...params },
  });
};
